import React from "react";
import { PurpleHeaderCard } from "./PurpleHeaderCard";

interface SimpleHeaderProps {
  title: string
  isDeleted: boolean
}

export const SimpleHeader = ({ title, isDeleted, children }: React.PropsWithChildren<SimpleHeaderProps>) =>
  <PurpleHeaderCard>
    <div className="purple-header-row">
      <div className="purple-header-info">
        <div className="purple-header-title purple-header-clamp">{title}</div>
        {children}
      </div>
      {isDeleted && <span className="purple-header-deleted-badge">{RESX.File.Deleted}</span>}
    </div>
  </PurpleHeaderCard>;
